/**
	kezeli a beviteli mezokbe beirhato karaktereket
	csak olyan esetben hasznalhato, ha a model frissites kesleltetve van (pl. ngModelOptions) vagy
	ha nem kapcsolodik funkcio a modelhez
*/
export const RestrictInputCharacters = () => {
	'ngInject';
	return {
		restrict: 'A',
		require: 'ngModel',
		priority: 100,
		link: ($scope, element, attrs, modelCtrl) => {
			if (attrs.type == 'radio' || attrs.type == 'checkbox') {
				return;
			}

			let options = $scope.$eval(attrs.restrictInputCharacters);
			let length = !isNaN(options.maxlength) ? '{0, ' + options.maxlength + '}' : '*';
			let characters = options.expression ? '[' + options.expression + ']' : '.';

			let fallbackValue = '';
			let regexp = new RegExp('^' + characters + length + '$');

			if (options.blockAll) {
				element.on('keydown', (e) => {
					e.preventDefault();
				});
			} else {
				setParsersFormatters(modelCtrl, regexp, element, fallbackValue);

				element.on('paste keyup', (e) => {
					fallbackValue = element.val();
				});

				element.on('input propertychange', (e) => {
					if (!regexp.test(element.val())) {
						element.val(fallbackValue);
					}
				});
			}
		}
	};

	function setParsersFormatters(modelCtrl, regexp, element, fallbackValue) {
		// programozott módosításnál
		modelCtrl.$formatters.unshift(function () {
			return regexp.test(modelCtrl.$modelValue) ? modelCtrl.$modelValue : fallbackValue;
		});
		// DOM-ból módosításnál
		modelCtrl.$parsers.unshift(function () {
			return regexp.test(modelCtrl.$viewValue) ? modelCtrl.$viewValue : fallbackValue;
		});
	}
};
